var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"pl-0 pr-0 pb-0"},[_c('v-col',{staticClass:"pl-0 pr-0",attrs:{"cols":"12"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }